// Attach getAyoba to the window object
window.getAyoba = function() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        try {
            return Android;
        } catch (error) {
            console.log('android userAgent test error');
        }
    }
    return null;
    // return new AyobaStub();
};

// Vue plugin definition
import Vue from "vue";
import AyobaStub from "@/ayobastub";

Vue.use({
    install(Vue) {
        Vue.mixin({
            methods: {
                getImg() {
                    return this.avatar || require("@/assets/no-image.jpg");
                },

                getSelfJid() {
                    const selfJid = window.getAyoba().getSelfJid();
                    console.log(selfJid);
                    return selfJid;
                },

                getAyoba() {
                    return window.getAyoba();
                },

                logAvailableMethods() {
                    if (!window.getAyoba()) {
                        return null;
                    }
                    console.log("List of methods available:");
                    Object.getOwnPropertyNames(window.getAyoba()).forEach((value) => {
                        console.log(value);
                    });
                },

                getlogs() {
                    console.log(window.location.href);
                    this.logAvailableMethods();
                },

                it_exists(method) {
                    if (!window.getAyoba()) {
                        return false;
                    }
                    console.log(method);
                    return Object.getOwnPropertyNames(window.getAyoba()).includes(method);
                },

                startChat() {
                    console.log('starting chat...');
                    if (this.it_exists("startConversation")) {
                        //let   jid = '2079a293fdf7bd670ded350992ad974b60e13a1f@dev.ayoba.me'
                        let jid = '2079a293fdf7bd670ded350992ad974b60e13a1f@ayoba.me'
                      
                        window.getAyoba().startConversation(jid);
                    } else {
                        console.log("conversation not defined");
                    }
                },
            }
        })
    }
})
